var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item-title',[_vm._v(" "+_vm._s(_vm.title)+" "),(_vm.showCount)?_c('span',[_vm._v(" ("+_vm._s(_vm.count)+") ")]):_vm._e(),(_vm.required)?_c('span',[_vm._v("*")]):_vm._e(),(_vm.hasErrors)?_c('v-icon',{staticClass:"inline_span ml-3",attrs:{"color":"red","dense":""}},[_vm._v(" mdi-alert-circle ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }